import "./style.scss"
interface Props {
  price: number
  percent?: number
  description: string
}
export const PriceCard = ({ price, percent, description }: Props) => {
  return (
    <div className="price-card">
      <div>
        <span>From</span> <h1>{price}€</h1> {percent != null && <span>+{percent}%</span>}
      </div>
      <div>{description}</div>
    </div>
  )
}
